import { connect } from 'react-redux'

import { ChefMenus } from '@components/groupOrders'

import services from '@services'
import presenters from '@presenters'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, UIService } = services

  const { GetCancelPreview, CancelGroupOrderObject } = coordinators
  const { pResponseCancellationPreview } = presenters.Api

  const getCancelPreview = GetCancelPreview({
    RestService,
    HandleError,
    pResponseCancellationPreview,
  })

  const cancelGroupOrderObject = CancelGroupOrderObject({
    RestService,
    HandleError,
  })

  const {
    InfoModal: {
      displayInfoModal: showInfoModal,
      dismissInfoModal: closeInfoModal,
    },
    FlashMessage: {
      displayFailureMessage,
      displayWarningMessage,
      displaySuccessMessage,
    },
  } = UIService

  return {
    getCancelPreview,
    cancelGroupOrderObject,
    showInfoModal,
    closeInfoModal,
    displaySuccessMessage,
    displayFailureMessage,
    displayWarningMessage,
  }
}

export default connect(undefined, mapDispatchToProps)(ChefMenus)
